/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postFeV1Shipments$Json } from '../fn/shipments/post-fe-v-1-shipments-json';
import { PostFeV1Shipments$Json$Params } from '../fn/shipments/post-fe-v-1-shipments-json';
import { postFeV1Shipments$Plain } from '../fn/shipments/post-fe-v-1-shipments-plain';
import { PostFeV1Shipments$Plain$Params } from '../fn/shipments/post-fe-v-1-shipments-plain';
import { postFeV1ShipmentsExport$Json } from '../fn/shipments/post-fe-v-1-shipments-export-json';
import { PostFeV1ShipmentsExport$Json$Params } from '../fn/shipments/post-fe-v-1-shipments-export-json';
import { postFeV1ShipmentsExport$Plain } from '../fn/shipments/post-fe-v-1-shipments-export-plain';
import { PostFeV1ShipmentsExport$Plain$Params } from '../fn/shipments/post-fe-v-1-shipments-export-plain';
import { ShipmentResponse } from '../models/shipment-response';

@Injectable({ providedIn: 'root' })
export class ShipmentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1Shipments()` */
  static readonly PostFeV1ShipmentsPath = '/v1/shipments';

  /**
   * Fetch shipments based on request parameters.
   *
   * Fetch shipments based on request parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Shipments$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Shipments$Plain$Response(params?: PostFeV1Shipments$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentResponse>> {
    return postFeV1Shipments$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch shipments based on request parameters.
   *
   * Fetch shipments based on request parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Shipments$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Shipments$Plain(params?: PostFeV1Shipments$Plain$Params, context?: HttpContext): Observable<ShipmentResponse> {
    return this.postFeV1Shipments$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShipmentResponse>): ShipmentResponse => r.body)
    );
  }

  /**
   * Fetch shipments based on request parameters.
   *
   * Fetch shipments based on request parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Shipments$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Shipments$Json$Response(params?: PostFeV1Shipments$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentResponse>> {
    return postFeV1Shipments$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch shipments based on request parameters.
   *
   * Fetch shipments based on request parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Shipments$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Shipments$Json(params?: PostFeV1Shipments$Json$Params, context?: HttpContext): Observable<ShipmentResponse> {
    return this.postFeV1Shipments$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShipmentResponse>): ShipmentResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1ShipmentsExport()` */
  static readonly PostFeV1ShipmentsExportPath = '/v1/shipments/export';

  /**
   * Export shipments to Excel with applied filters.
   *
   * Export shipments to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1ShipmentsExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1ShipmentsExport$Plain$Response(params?: PostFeV1ShipmentsExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1ShipmentsExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export shipments to Excel with applied filters.
   *
   * Export shipments to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1ShipmentsExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1ShipmentsExport$Plain(params?: PostFeV1ShipmentsExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1ShipmentsExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export shipments to Excel with applied filters.
   *
   * Export shipments to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1ShipmentsExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1ShipmentsExport$Json$Response(params?: PostFeV1ShipmentsExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1ShipmentsExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export shipments to Excel with applied filters.
   *
   * Export shipments to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1ShipmentsExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1ShipmentsExport$Json(params?: PostFeV1ShipmentsExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1ShipmentsExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
